import { render, staticRenderFns } from "./SFormDeleteInventoryComp.vue?vue&type=template&id=6e317992&"
import script from "./SFormDeleteInventoryComp.vue?vue&type=script&lang=js&"
export * from "./SFormDeleteInventoryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports